import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./assets/css/App.css";
import App from "./App";
import { toast, ToastContainer } from "react-toastify";
import store from "./redux/Store";
import { persistor } from "./redux/Store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider, useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import DisableScrollForNumberInputs from "components/DisableScrollForNumberInputs/DisableScrollForNumberInputs";
import Pusher from "pusher-js"; // Ensure Pusher is correctly imported
import { selectUserInfo } from "./redux/userSlice";
import { addMessage } from "./redux/messageSlice";
import notificationSound from "./assets/Sound/notification.wav";
import { IoLogoWhatsapp, IoMdChatboxes } from "react-icons/io";
import ChatApp from "views/admin/CRM/Chat/ChatApp";
import { addFollowupReminder } from "./redux/followupReminderSlice";
import { addWhatsAppMessage } from "./redux/whatsAppSlice";

const RootComponent = () => {
  const userInfo = useSelector(selectUserInfo);
  const messages = useSelector((state) => state?.messages);
  const [realMessage, setRealMessage] = useState();

  const audio = new Audio(notificationSound);

  // Initialize Pusher
  const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
  });

  const dispatch = useDispatch();
  useEffect(() => {
    if (!userInfo.data) return;

    if (!userInfo.data.id) return;

    if (!userInfo) return;

    // Enable Pusher logging for debugging (optional, remove in production)
    Pusher.logToConsole = false;

    // Subscribe to the desired channel
    const channel = pusher.subscribe("my-channel");
    const followupchannel = pusher.subscribe(
      "followup-channel." + userInfo?.data?.id
    );

    followupchannel.bind("App\\Events\\FollowupReminderSent", function (data) {
      audio.play();      
      dispatch(addFollowupReminder(data));
      toast.success(data?.message);
    });

    // Bind to an event and handle incoming data
    channel.bind("my-event", function (data) {
      // Handle the received data
      // console.log(data, "Received message from Pusher");
      setRealMessage(data);

      if (
        data.receiver_id === userInfo.data?.id &&
        userInfo?.data?.id !== data.sender_id
      ) {
        // Play notification sound
        dispatch(addMessage(data));
        toast.success(
          <div>
            <div style={{ fontSize: "14px", fontWeight: "bolder" }}>
              {data.name}
            </div>
            <div style={{ fontSize: "12px", color: "#888" }}>
              {data.message}
            </div>
          </div>
        );
        audio.play();
      }
      // Dispatch action to update Redux state (if needed)
      // dispatch(addMessage(data));
    });

    // Cleanup to avoid multiple subscriptions
    return () => {
      channel.unbind("my-event");
      pusher.unsubscribe("my-channel");
      followupchannel.unbind("App\\Events\\FollowupReminderSent");
      pusher.unsubscribe("followup-channel." + userInfo?.data?.id);
    };
  }, [realMessage, messages, userInfo, userInfo.data]);

  // twilio whatsapp messaage notification

  useEffect(() => {
    if (!userInfo?.data?.id) return;

    const whatsAppChannel = pusher.subscribe("whatsapp-messages");

    const handleWhatsAppMessage = (data) => {
      audio.play();
      toast.info(
        <div className="flex items-start gap-3">
          {/* WhatsApp icon */}
          <IoLogoWhatsapp className="mt-1 text-2xl text-green-500" />

          {/* Message content */}
          <div className="flex flex-col">
            {/* Sender */}
            <span className="text-sm font-semibold">
              {data?.customer?.full_name || "Unknown Sender"}
            </span>

            {/* Phone number */}
            <span className="text-xs text-gray-500">
              {data?.customer?.phone_number || ""}
            </span>

            {/* Optional body */}
            <span className="mt-1 text-sm">
              {data?.body || "New WhatsApp message received"}
            </span>
          </div>
        </div>,
        {
          autoClose: 5000, // disappear after 5 sec
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: false, // optional
          position: "top-right",
          icon: false, // remove default info icon
        }
      );
      // Save in Redux
      dispatch(addWhatsAppMessage(data));
    };

    whatsAppChannel.bind("message.received", handleWhatsAppMessage);

    return () => {
      whatsAppChannel.unbind("message.received", handleWhatsAppMessage);
      pusher.unsubscribe("whatsapp-messages");
    };
  }, [userInfo?.data?.id]);

  return (
    <>
      <DisableScrollForNumberInputs />
      <App />
      <ToastContainer
        style={{
          maxHeight: "90vh", // limit the height
          overflowY: "auto", // enable scroll
          paddingRight: "10px", // optional for better scroll visibility
        }}
      />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RootComponent />
      </PersistGate>
    </Provider>
  </BrowserRouter>
);
